import { jsx } from 'react/jsx-runtime';

const SvgMiscStepsFill = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M13 8H8v5H3v8h18V3h-8v5Z" }) }));

export { SvgMiscStepsFill as default };
//# sourceMappingURL=MiscStepsFill.es.js.map
